import React from "react";
import { Nav } from "react-bootstrap";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import "./admin.css";

const AdminLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        localStorage.removeItem("isAdmin");
        navigate("/login");
    };

    // 🔥 ACTIVE LINK STYLE
    const isActive = (path) =>
        location.pathname === path ? "active-link" : "";

    return (
        <div className="d-flex">

            {/* ================= SIDEBAR ================= */}
            <div
                className="bg-dark text-white p-3 d-flex flex-column"
                style={{ width: "230px", minHeight: "100vh" }}
            >

                {/* LOGO */}
                <div className="text-center mb-4">
                    <img
                        src="/img/Logo.png"
                        alt="Logo"
                        style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "contain",
                            borderRadius: "10px",
                        }}
                    />
                    <h6 className="mt-2">Admin Panel</h6>
                </div>

                {/* NAVIGATION */}
                <Nav className="flex-column">

                    <Nav.Link
                        className={`text-white ${isActive("/admin/dashboard")}`}
                        onClick={() => navigate("/admin/dashboard")}
                    >
                        📊 Dashboard
                    </Nav.Link>

                    <Nav.Link
                        className={`text-white ${isActive("/admin/add-news")}`}
                        onClick={() => navigate("/admin/add-news")}
                    >
                        📰 Add News
                    </Nav.Link>

                    <Nav.Link
                        className={`text-white ${isActive("/admin/manage-news")}`}
                        onClick={() => navigate("/admin/manage-news")}
                    >
                        🛠 Manage News
                    </Nav.Link>

                    {/* USERS (Guest Authors) */}
                    <Nav.Link
                        className={`text-white ${isActive("/admin/user")}`}
                        onClick={() => navigate("/admin/user")}
                    >
                        👤 user
                    </Nav.Link>

                </Nav>

                {/* LOGOUT BUTTON (BOTTOM) */}
                <div className="mt-auto">
                    <Nav.Link
                        className="text-danger"
                        onClick={handleLogout}
                    >
                        🚪 Logout
                    </Nav.Link>
                </div>

            </div>

            {/* ================= MAIN CONTENT ================= */}
            <div className="flex-grow-1 p-4 bg-light">
                <Outlet />
            </div>

        </div>
    );
};

export default AdminLayout;